import React, {useEffect, useRef, useState} from "react";
import TextField from "@mui/material/TextField/TextField";
import Button from "@mui/material/Button";
import constants from "../../../../config/constants";

import axios from "axios";


export const Level1 = ({user, password, setUser, emitInput, setANewClue}) => {

    const [inputValue, setInputValue] = useState("");
    const mobile = window.innerWidth < 700;
    const [symmetry, setSymmetry] = useState(false);
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");

    const [showLevel1, setShowLevel1] = useState(true);
    const [showLevel2, setShowLevel2] = useState(true);
    const [showLevel3, setShowLevel3] = useState(true);

    useEffect(() => {

    }, []);

    function deepEqual(obj1, obj2) {
        if (obj1 === obj2) return true;

        // Check if both are objects and not null
        if (typeof obj1 !== 'object' || obj1 === null ||
            typeof obj2 !== 'object' || obj2 === null) {
            return false;
        }

        // Get keys from both objects
        const keys1 = Object.keys(obj1);
        const keys2 = Object.keys(obj2);

        // Different number of keys => not equal
        if (keys1.length !== keys2.length) return false;

        // Check each key/value recursively
        for (let key of keys1) {
            if (!keys2.includes(key)) return false;
            if (!deepEqual(obj1[key], obj2[key])) return false;
        }

        return true;
    }

    function sendInput() {
        if(inputValue === "03/09/22"){
            window.location = "https://elodiekevin.net";
            return;
        }
        const value = inputValue.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/[^a-z]/g, '')
        emitInput(value);
        setError("");
        if (value === "symetrie") {
            setSymmetry(!symmetry);
            return;
        }
        if (value === "puzzle") {
            window.location = "./puzzle";
            return;
        }
        console.log('coucou');
        console.log(password, password);
        axios.post(constants.api.basePath + "/anniv2025/input", {inputValue, username: user.username, password}).then(res => {
            setInputValue("");
            if (!deepEqual(res.data, user)) {
                setMessage("correct");
                setTimeout(() => setMessage(""), 2000);
            }
            setUser(res.data);
        }).catch(err => {
            setInputValue("");
            console.log(err);
            setError(err.response.data);
        });
    }

    function hasAtLeastOneLevel1() {
        return user.level1 && Object.keys(user.level1).length > 0;
    }

    function hasCompletedLevel1() {
        return user.level1 && Object.keys(user.level1).length >= 5;
    }

    function hasAtLeastOneLevel2() {
        return user.level2 && Object.keys(user.level2).length > 0;
    }

    function hasCompletedLevel2() {
        return user.level2 && Object.keys(user.level2).length >= 5;
    }

    function hasAtLeastOneLevel3() {
        return user.level3 && Object.keys(user.level3).length > 0;
    }

    function hasCompletedLevel3() {
        return user.level3 && Object.keys(user.level3).length >= 5;
    }

    function getProgression() {
        let progression = 1;
        if (user.level1) {
            progression += Object.keys(user.level1).length;
        }
        if (user.level2) {
            progression += Object.keys(user.level2).length;
        }
        if (user.level3) {
            progression += Object.keys(user.level3).length;
        }
        if(user.video) {
            progression += 1;
        }
        if(user.livre) {
            progression += 1;
        }
        return Math.floor(100 * progression / 18);
    }

    return (
        <div>
            <div className={"input-box"}>
                <TextField
                    type="text"
                    placeholder=""
                    hiddenLabel
                    variant="outlined"
                    style={mobile ? {width: "100%"} : {}}
                    size="small"
                    value={inputValue}
                    onChange={(e) => setInputValue(e.target.value)}
                    required
                />

                <Button variant="contained" type="submit" onClick={() => sendInput()}>
                    Envoyer
                </Button>
                <div>
                    <span style={{color: "green"}}>{message}</span>
                    <span style={{color: "firebrick"}}>{error}</span>
                </div>
            </div>
            <div className={'image-holder' + (symmetry ? " symetry" : "")}>
                {
                    <div>
                        <img style={{zIndex: 100, position: 'relative'}}
                             src="/public/anniv/2025/level1_frame.png"/>
                        {
                            user.level1 ? Object.keys(user.level1).filter(key => !symmetry || key !== "banquetdivin").map((key, i) =>
                                    <img style={{zIndex: 101 + i}}
                                         key={"key_1_" + i}
                                         src={"/public/anniv/2025/level1_"+ key + ".png"}/>
                                )
                                : undefined
                        }
                        <img style={{
                            zIndex: 102,
                            transform: "none",
                            opacity: (symmetry && user.level1 && user.level1.banquetdivin) ? 1 : 0
                        }}
                             src="/public/anniv/2025/level1_symetry.png"/>
                        {
                            user.level2 ? Object.keys(user.level2).map((key, i) =>
                                    <img style={{zIndex: 106 + i}}
                                         key={"key_2_" + i}
                                         src={"/public/anniv/2025/level2_"+ key + ".png"}/>
                                )
                                : undefined
                        }
                        {
                            user.level3 ? Object.keys(user.level3).map((key, i) =>
                                    <img style={{zIndex: 111 + i}}
                                         key={"key_3_" + i}
                                         src={"/public/anniv/2025/level3_"+ key + ".png"}/>
                                )
                                : undefined
                        }
                    </div>
                }
            </div>
            {
                getProgression() > 20 ?
                    <div style={{textAlign: "center"}}>
                        - Progression : {getProgression()}% -
                    </div> : undefined
            }
            {
                hasCompletedLevel1() || hasAtLeastOneLevel2() ?
                    <h2>
                        Les consignes du niveau 1
                        {
                            hasCompletedLevel1() ?
                                <span style={{fontSize: "0.8em", color: "gold"}}> (terminé)</span> :
                                undefined
                        }</h2> : undefined
            }
            <div style={{textAlign: "center", marginBottom: "12px"}}>
                <Button variant="contained" type="submit" onClick={() => {
                    window.location.href = "https://youtu.be/a20Q9K_hGaM"
                }}>
                    La Bande Annonce
                </Button>
            </div>
            <div>
                {
                    Object.keys(user.level1Descriptions).filter(key => user.level1 && user.level1[key]).map(key => <div key={key}>
                        - {user.level1Descriptions[key]}<br/>
                    </div>)
                }
            </div>
            {
                hasAtLeastOneLevel2() ?
                    <h2>
                        Les consignes du niveau 2
                        {
                            hasCompletedLevel2() ?
                                <span style={{fontSize: "0.8em", color: "gold"}}> (terminé)</span> :
                                undefined
                        }
                    </h2> : undefined
            }
            {
                hasCompletedLevel1() && !user.video ?
                    <div>
                        <br/>
                        <br/>
                        Pour accéder au niveau 2, vous devez trouver un média de 5 lettres. Chaque réponse du niveau précédent contient une de ces lettres, et l'ordre est le bon. Pour que cela reste facile, la première lettre est la 4ème.
                        <br/>
                        <br/>
                    </div> : undefined
            }
            {
                user.video ?
                    <div style={{textAlign: "center", marginBottom: "12px"}}>
                        <Button variant="contained" type="submit" onClick={() => {
                            window.location.href = "https://youtu.be/apQKTSbhg-o"
                        }}>
                            La vidéo
                        </Button>
                    </div> : undefined
            }
            <div>
                {
                    Object.keys(user.level2Descriptions).filter(key => user.level2 && user.level2[key]).map(key => <div
                        key={key}>
                        - {user.level2Descriptions[key]}<br/>
                    </div>)
                }
            </div>
            {
                hasAtLeastOneLevel3() ?
                    <h2>
                        Les consignes du niveau 3
                        {
                            hasCompletedLevel3() ?
                                <span style={{fontSize: "0.8em", color: "gold"}}> (terminé)</span> :
                                undefined
                        }
                    </h2> :
                    undefined
            }
            {
                hasCompletedLevel2() && !user.livre ?
                    <div>
                        <br/>
                        <br/>
                        Pour accéder au niveau 3, vous devez trouver un média de 5 lettres. Chaque réponse du niveau précédent contient une de ces lettres, et l'ordre est le bon. Pas besoin d'indice supplémentaire ce coup-ci.
                        <br/>
                        <br/>
                    </div> : undefined
            }
            {
                user.livre ?
                    <div style={{textAlign: "center", marginBottom: "12px"}}>
                        <Button variant="contained" type="submit" onClick={() => setANewClue(1)}>
                            Un nouvel Indice
                        </Button>
                    </div> : undefined
            }
            <div>
                {
                    Object.keys(user.level3Descriptions).filter(key => user.level3 && user.level3[key]).map(key => <div
                        key={key}>
                        - {user.level3Descriptions[key]}<br/>
                    </div>)
                }
            </div>
        </div>
    )
}
